import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { Scadenza } from '../../../models/scadenza';

import { ScadenzaRinvioConcreteFormComponent } from './scadenza-rinvio-concrete-form.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [modale_rinvio_scadenza]',
  templateUrl: 'scadenza-mod-rinvio.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ScadenzaModRinvioComponent {
  @Output() onReturn: EventEmitter<Scadenza> = new EventEmitter<Scadenza>();
  @ViewChild('formScadenzarioRinvio') formScadenzarioRinvio: ScadenzaRinvioConcreteFormComponent;

  inizializza(urlRinvio: string, scadenza: Scadenza, idSezione: string, isAdempimenti: boolean = false) {
    this.formScadenzarioRinvio.inizializza(urlRinvio, scadenza, idSezione, isAdempimenti);
    openModal('modalrinvioscad');
  }

  createForm() {
    this.formScadenzarioRinvio.createForm();
  }

  manageModal(scadenza: Scadenza) {
    if (scadenza) {
      closeModal('modalrinvioscad');
      this.onReturn.emit(scadenza);
    }
  }
}
